import {
  HousingApplicationDto,
  HousingSiteResultType,
  HousingIntakeScenario,
  HousingIntakeScenarioDto,
  HousingApplication,
  HousingSiteResult,
} from "~/api";

import { useHousingSiteStore } from "~/YYC_Housing/stores/HousingSiteStore";

export const formatApplyingForAndHMB = (
  housingApplication: HousingApplicationDto | HousingApplication,
) => {
  let eligibleCount = 0;
  let selectedCount = 0;
  let applyingForSummary = "";
  let hmbSummary = "";

  const counter: Record<string, number> = {};
  const seenSites = new Set<string>();

  housingApplication.siteResults?.forEach((siteResult: HousingSiteResult) => {
    if (siteResult.resultType !== HousingSiteResultType.PREFERRED) return;
    const siteKey = `${siteResult.hmb}|${siteResult.siteCode}`;
    if (seenSites.has(siteKey)) return;
    seenSites.add(siteKey);

    if (siteResult.hmb in counter) {
      counter[siteResult.hmb]++;
    } else {
      counter[siteResult.hmb] = 1;
    }
    selectedCount++;
  });
  const finderInput =
    "finderInput" in housingApplication
      ? housingApplication.finderInput
      : undefined;
  eligibleCount = finderInput?.totalEligibleSites ?? selectedCount;

  if (Object.keys(counter).length === 0) {
    hmbSummary = "-";
  } else {
    hmbSummary = Object.entries(counter)
      .map(([key, count]) => `${key} (${count})`)
      .join(", ");
  }

  applyingForSummary = `Selected (${selectedCount}/${eligibleCount})`;

  return { hmbSummary, applyingForSummary };
};

export function formatIntakeScenarioName(
  scenario: HousingIntakeScenario | HousingIntakeScenarioDto | undefined,
): string {
  if (!scenario?.housingSiteGuid) {
    return "Unknown";
  }

  const housingSiteStore = useHousingSiteStore();
  // Pull a representative unit number from the first vacancy's UnitNumbers list,
  // falling back to the scenario-level effectiveUnitNumber.
  const full = scenario as Partial<HousingIntakeScenario> &
    Partial<HousingIntakeScenarioDto>;
  const firstVacancy = full.vacancies?.[0];
  const unitLabel =
    firstVacancy?.unitNumbers?.[0] ?? full.effectiveUnitNumber ?? "";
  return `${housingSiteStore.getNameByGuid(scenario.housingSiteGuid)}${unitLabel ? ` - ${unitLabel}` : ""}`;
}

export const contactHistoryActivityTypeOptions = [
  { label: "📝 Notes", value: "Notes" },
  { label: "📞 Phone Call", value: "PhoneCall" },
  { label: "📧 Email", value: "Email" },
  { label: "💬 Messaging", value: "Messaging" },
  { label: "🤝 Meeting", value: "MeetingActivity" },
  { label: "Task", value: "TaskActivity" },
  { label: "On Hold Task", value: "On Hold Task" },
];
